module.exports = __webpack_public_path__ + "img/labmemtest_text_btn01_jp.de5359d2.png";